import React, { useState } from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
    padding: 50px 0;
    max-width: 1000px;
    margin: 80px auto;  
    padding: 0 20px;
`;

const SectionTitle = styled.h2`
    font-size: 24px;
    text-align: left;
    margin-bottom: 30px;
    font-weight: 600;
    color: #333; // 필요에 따라 색상 변경
    position: relative;
    
    &:after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 50px;
        height: 3px;
        background-color: #1a4786; // 필요에 따라 색상 변경
    }
`;

const VideoPreviewGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const VideoTitle = styled.h3`
    font-size: 16px;
    font-weight: 500;
    color: #333;
    padding: 15px;
    margin: 0;
    background-color: #f9f9f9;
    border-bottom: 1px solid #eee;
    text-align: left;
    height: 60px;
    display: flex;
    align-items: center;
`;

const VideoPreviewItem = styled.div`
    position: relative;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
    }
`;

const PreviewImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
`;

const PlayIconOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
    
    &:hover {
        background-color: rgba(0, 0, 0, 0.3);
    }
`;

const PlayIcon = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-left: 25px solid #ff0000;
        border-bottom: 15px solid transparent;
        margin-left: 5px;
    }
`;

// Modal components
const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalContainer = styled.div`
    background-color: white;
    border-radius: 8px;
    max-width: 90%;
    width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px;
    position: relative;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #333;
    z-index: 10;
`;

const VideoWrapper = styled.div`
    position: relative;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
    width: 100%;
`;

const VideoIframe = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
`;

const YouTubeSection = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);

    // 중앙대학교 총학생회 유튜브 영상 정보
    const videos = [
        {
        id: "oKeoYQCYr3Q", // 실제 비디오 ID로 교체 필요
        title: "🎓당신이 입을 학위복을 투표하라🎓학위복 오프라인 품평회 / 전체 실물 / 앞,뒷면 / 학위모"
        },
        {
        id: "RdCbt4pFwKg", // 실제 비디오 ID로 교체 필요
        title: "5/1 노동절, 중앙대학교 학내 노동자들의 아침☀️ 🔹학생회관, 중앙도서관 등🔹"
        }
    ];

    const getThumbnailUrl = (videoId) => {
        // 고화질(hqdefault) 썸네일 URL 반환
        // 다른 옵션: mqdefault (중화질), sddefault (표준화질), maxresdefault (최고화질)
        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    };

    const openModal = (videoId) => {
        setSelectedVideo(videoId);
    };

    const closeModal = () => {
        setSelectedVideo(null);
    };

    return (
        <SectionContainer>
        <SectionTitle>총학생회 공식 유튜브</SectionTitle>
        <VideoPreviewGrid>
            {videos.map((video, index) => (
                <VideoPreviewItem 
                    key={index} 
                    onClick={() => openModal(video.id)}
                >
                <VideoTitle>{video.title}</VideoTitle>
                <PreviewImage 
                    src={getThumbnailUrl(video.id)} 
                    alt={video.title} 
                />
                <PlayIconOverlay>
                <PlayIcon />
                </PlayIconOverlay>
            </VideoPreviewItem>
            ))}
        </VideoPreviewGrid>

        {selectedVideo && (
            <ModalOverlay onClick={closeModal}>
            <ModalContainer onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={closeModal}>&times;</CloseButton>
                <VideoWrapper>
                <VideoIframe
                    src={`https://www.youtube.com/embed/${selectedVideo}`}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
                </VideoWrapper>
            </ModalContainer>
            </ModalOverlay>
        )}
        </SectionContainer>
    );
};

export default YouTubeSection;